'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var MODIFIED_ELEMENTS_SET = exports.MODIFIED_ELEMENTS_SET = 'MODIFIED_ELEMENTS_SET';
var MODIFIED_ELEMENTS_ADD = exports.MODIFIED_ELEMENTS_ADD = 'MODIFIED_ELEMENTS_ADD';
var MODIFIED_ELEMENTS_ERROR = exports.MODIFIED_ELEMENTS_ERROR = 'MODIFIED_ELEMENTS_ERROR';


//////////////////
// WEBPACK FOOTER
// ./src/client/notifications/notificationConstants.js
// module id = 748
// module chunks = 0